import BottomNavigation from "@mui/material/BottomNavigation";
import BottomNavigationAction from "@mui/material/BottomNavigationAction";
import Box from "@mui/material/Box";
import axios from "axios";
import dateFormat from "dateformat";
import { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import profileStaff from "../../../assets/images/default-profile-icon-5.jpg";
import Barth from "../../../assets/svg/bar.svg";
import joined from "../../../assets/svg/joined.svg";
import male from "../../../assets/svg/male 1.svg";
import Pan from "../../../assets/svg/PenEtat.svg";
import Phone from "../../../assets/svg/Phone.svg";
import email from "../../../assets/svg/user.svg";
import UserNAme from "../../../assets/svg/UserNAme.svg";
import Addmember from "../../../components/Addmember";
import OrdersOf from "../../../components/OrdersOf";
import { GET_ALL_OPERATER_USERS } from "../../../URLs/Apis";
import AgentOprator from "./AgentOprator";
import "./memder.css";


const memberInfo = [
  { label: 'Joined On', icon: joined, key: 'joined_at', format: (date) => date ? dateFormat(date, "fullDate") : 'no Data' },
  { label: 'Mobile Number', icon: Phone, key: 'phone_number', format: (val) => val || 'no Data' },
  { label: 'Birth Date', icon: Barth, key: 'birthdate', format: (date) => date ? dateFormat(date, "fullDate") : 'no Data' }, // Use birthdate key from API
  { label: 'Gender', icon: male, key: 'gender', format: (val) => val || 'no Data' },
  { label: 'Username', icon: UserNAme, key: 'username', format: (val) => val || 'no Data' },
  { label: 'Email', icon: email, key: 'email', format: (val) => val || 'no Data' },
];


function Member() {

  const { user } = useSelector((state) => state.auth); 

  const [operaterData, setOperaterData] = useState(null); 
  const [errors, setErrors] = useState(null); 
  const [loading, setLoading] = useState(true); 
  const [showEditModal, setShowEditModal] = useState(false);
  const memberId = window.location.href.split("/").at(-1);
  const getStaffData = () => {
    setLoading(true); 

    // const token = "1|uXWWHVAxUbLR94IuQ07nZUT5306vlnjfGFo4AUoR16bcf002";

    const token = user?.token;
    
    console.log(user?.token);
    
    const headers = {
      Authorization: `Bearer ${token}`, 
    };
    
    axios
      .get(
        `${GET_ALL_OPERATER_USERS}/${memberId}`, 
        {
          headers,
        }
      )
      .then((response) => {
        console.log("Operator Data:", response.data.data.operator);
        setOperaterData(response.data.data.operator);
        setErrors(null); 
      })
      .catch((error) => {
        console.error("Error fetching operator data:", error);
        setErrors(error); 
        setOperaterData(null); 
      })
      .finally(() => {
         setLoading(false); 
      });
  };

  useEffect(() => {
    if (user?.token && memberId) { 
      getStaffData();
    }
  }, [user?.token, memberId]); 

  const handleEditClick = () => {
    setShowEditModal(true);
  };

  const handleCloseEditModal = () => {
    setShowEditModal(false);
  };

  const [value, setValue] = useState(0); 

  if (loading) {
    return <div className="profile">Loading member data...</div>; 
  }

  if (errors) {
      
     const errorMessage = errors.response?.data?.message || errors.message || 'Failed to load member data.';
     return <div className="profile text-danger">Error: {errorMessage}</div>;
  }

  return (
    <>
      <div className="profile">
        {operaterData && (
          <Addmember
            show={showEditModal}
            onHide={handleCloseEditModal}
            memberData={operaterData}
            onSubmitSuccess={getStaffData}
          />
        )}
        <div className="memberProfile">
          <div className="profileCard">
            <div className="img">
              <img
                className="personRel"
                src={
                  operaterData?.profile_photo_url
                    ? operaterData?.profile_photo_url
                    : profileStaff
                }
                alt={`${operaterData?.name || "Member"}'s profile`}
                onError={(e) => {
                  e.target.onerror = null; 
                  e.target.src = profileStaff; 
                }}
              />

              <div className="theRolesOfPerson">
                {operaterData?.roles?.[0] || "Agent"}
              </div>
            </div>
            <div className="profileName">
              <div className="nameOfMemberProfile">{operaterData?.name}</div>

              <img
                className="edateTheName"
                src={Pan}
                alt="Edit Member Name"
                onClick={handleEditClick}
                style={{ cursor: "pointer" }}
              />
            </div>
            <div className="stuffprofileinfo">
              {memberInfo.map((item, i) => {
                const dataValue = operaterData?.[item.key];

                const formattedValue = item.format(dataValue);

                return (
                  <div className="memberInfoItem" key={item.key}>
                    <img
                      className="memberInfoItem_img"
                      src={item.icon}
                      alt={`${item.label} icon`}
                    />
                    <div className="memberInfotext">
                      {/* Display the formatted value */}
                      {formattedValue}
                    </div>
                  </div>
                );
              })}
            </div>
          </div>
        </div>
        <div className="memberDetals">
          <div className="memberMenuBar">
            <Box>
              <BottomNavigation
                showLabels
                value={value}
                onChange={(event, newValue) => {
                  setValue(newValue);
                }}
                className="memberMenuBar_bottom"
              >
                <BottomNavigationAction
                  className="BottomNavigationAction"
                  label="Orders"
                />
                {["supervisor", "admin"].includes(user?.operator.role) ? (
                  <BottomNavigationAction
                    className="BottomNavigationAction"
                    label="Permissions"
                  />
                ) : null}
              </BottomNavigation>
            </Box>
          </div>
          {value === 0 ? (
            <OrdersOf />
          ) : user?.operator?.role &&
            ["supervisor", "admin"].includes(user?.operator?.role) &&
            value === 1 ? (
            <AgentOprator agentID={operaterData.id} />
          ) : null}
        </div>
      </div>
    </>
  );
}

export default Member;